import { useTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import PageTitle from "../../../layouts/PageTitle";
import RestockHistory from "../../../components/Custom/StockControl/Restock/RestockHistory";

const RestockList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('restock')} motherMenu={t('stock_control')} />
            <Row>
                <Col className="col-md-12">
                    <RestockHistory/>
                </Col>
            </Row>
        </>
    );
}

export default RestockList;